<script setup>
import ScrollTrigger from 'gsap/ScrollTrigger'
import GlobalEmitter from '~/glxp/utils/emitter'
import { useLoaderStore } from '~~/store/loader'

useHead({
  title: 'Fly With Us | Virgin Galactic',
})

// Handlers
function handleClose() {
  // TODO - Go to homepage?
}

/**
 * Lifecycle
 */
const loaderState = useLoaderStore()
onMounted(() => {
  loaderState.isOpen = false
  ScrollTrigger.refresh()

  GlobalEmitter.emit('webgl_raf_stop')
  GlobalEmitter.emit('webgl_loading_progress', { progress: 100 })
})
</script>

<template>
  <article class="page-fly-with-us">
    <FlyWithUsForm @on-close="handleClose" />
  </article>
</template>

<style lang="scss">
// Vendors
@import 'styles/vendors/sass-mq/mq';

.page-fly-with-us {
  width: 100%;

  @include mq($from: 'l') using($from) {
    height: var(--real-height, 100vh);
  }
}
</style>
